import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../loaders/loader.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const requestType = req.params.get('Request-Type') || '';
  if (!requestType) return next(req);
  const loadingService = inject(LoaderService);

  loadingService.isLoading[requestType].next(true);
  return next(req).pipe(
    finalize(() => {
      loadingService.isLoading[requestType].next(false);
    })
  );
};
